<template>
    <div class="mainApp">
        <div class="mainView">
            <div class="mainContent">
                <van-row type="flex" justify="center">
                    <van-col span="6" class="avtor"></van-col>
                </van-row>
                <van-row type="flex" justify="center">
                    <van-col span="6" class="phone">{{
                        userInfo.account
                    }}</van-col>
                </van-row>
                <van-row type="flex" justify="center">
                    <van-col span="14" class="evidenceType"
                        >给您分享证据</van-col
                    >
                </van-row>
                <div class="fwCode">
                    <van-row type="flex" justify="center" class="error">
                        <van-col span="20" v-if="isError">{{
                            errorText
                        }}</van-col>
                    </van-row>
                    <van-row type="flex" justify="center">
                        <van-col span="8">
                            <van-field
                                v-model="accessCode"
                                placeholder="请输入访问码"
                                class="vanInput"
                                @focus="isError = false"
                            />
                        </van-col>
                    </van-row>
                </div>
                
                <van-row type="flex" justify="center">
                    <van-col span="8">
                        <div class="submit" @click="goNext">提交</div>
                    </van-col>
                </van-row>
                <Footer />
            </div>
        </div>
        <a-modal
            title="提示"
            :keyboard="false"
            :visible="visible"
            :closable="false"
            class="myDia"
        >
            <template slot="footer">
                <a-button size="large" key="submit" type="primary" @click="visible=false">
                    确定
                </a-button>
            </template>
            <div class="icon"><i class="el-icon-ali-jinggao"></i></div>
            <p class="font"> 分享证据已失效，请与证据持有者联系。</p>
        </a-modal>
        <div id="captcha-element"></div>
    </div>
</template>

<script>
import NoTrace from '@/utils/noTrace.js';
import Footer from "@/components/Computer/Footer/index.vue";
import { shareValidate ,shareLogin} from "@/api/service.js";
export default {
    data() {
        return {
            accessCode: "",
            userInfo: {},
            isError: false,
            errorText: "提取证错误",
            randomKey: "",
            visible:false,
            nvc:'',
        };
    },

    components: { Footer },

    computed: {},

    created() {
        if(this.$route.query.randomKey){
            this.init();
        }else{
            this.$router.push({
                path: "/FileShow",
            });
        }
    },

    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },

    methods: {
        async init() {
            let { randomKey } = this.$route.query;
            this.randomKey = randomKey;
            try {
                let res = await shareValidate({
                    randomKey,
                });
                sessionStorage.removeItem("codeMessage");
                sessionStorage.setItem('userinfo', JSON.stringify(res))
                if (res.accessStatus == 1) {
                    this.userInfo = res;
                    zhuge.track("证据分享_输入访问码", {
                        '端': "PC",
                    });
                } else {
                    this.$router.push({
                        path: "/FileShow",
                    });
                }
            } catch (error) {
                sessionStorage.removeItem("userinfo");
                sessionStorage.setItem('codeMessage', JSON.stringify({...error,randomKey}))
                if(error.code==20005){
                    console.log('证据分享失效');
                }else if([20018,20019,20020].includes(error.code)){
                    console.log('跳转弹框报统一错误')
                }else{
                    this.$toast(error.message);
                }
                this.$router.push({
                    path:'/FileShow',
                })
            }
        },
        async goNext() {
            if (this.accessCode !== "") {
                let that=this;
                // 开始获取无痕验证码
                NoTrace.start((nvc) => {
                    this.nvc = nvc
                }, this.executeFun, {
                    randomKey: that.$route.query.randomKey,
                    accessCode:that.accessCode,
                    nvc: '',
                    afsVersion: 2
                })
            } else {
                this.isError = true;
                this.errorText = "请输入访问码";
            }
        },
        executeFun(params){
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await shareLogin(params);
                    that.$router.push({
                        path: "/FileShow",
                    });
                    resolve(res)
                }catch (err) {
                    this.isError = true
                    this.errorText = err.message
                    reject(err)
                }
            })
        },
    },
};
</script>
<style lang="less" scoped>
.mainApp {
    background: #f5f5f5;
    padding-top: 13px;
    box-sizing: border-box;
    overflow: auto;
    height: calc(100vh - 64px);
    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }
    
    &::-webkit-scrollbar-track-piece {
        background-color: rgba(0, 0, 0, 0.2);
        -webkit-border-radius: 6px;
    }
    
    &::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(125, 125, 125, 0.7);
        -webkit-border-radius: 6px;
    }
    
    &::-webkit-scrollbar-thumb:horizontal {
        width: 5px;
        background-color: rgba(125, 125, 125, 0.7);
        -webkit-border-radius: 6px;
    }
}
.mainView {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding-top: 80px;
    padding-bottom: 40px;
    min-height: calc(100vh - 128px);
    box-sizing: border-box;
}
.mainContent {
    text-align: center;
    .avtor {
        background: url("../../assets/images/avtor.png") no-repeat;
        background-size: contain;
        width: 56px;
        height: 56px;
    }
    .phone {
        font-size: 18px;
        font-weight: bold;
        color: #262626;
        margin: 44px 0 32px 0;
    }
    .evidenceType {
        font-size: 18px;
        font-weight: 400;
        color: #878787;
        margin-bottom: 60px;
    }
    .vanInput {
        padding: 0;
        border-radius: 10px;
        margin-bottom: 40px;
        /deep/ input {
            height: 60px;
            background: #f1f1f1;
            border-radius: 10px;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            text-align: center;
        }
    }
    .submit {
        background: #3988fe;
        border-radius: 10px;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        padding: 18px 0;
        cursor: pointer;
    }
    .fwCode{
        position: relative;
        .error {
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            color: #f70f0f;
            text-align: center;
            position: absolute;
            top:-30px;
        }
    }
}
.myDia{
    /deep/.ant-modal-header{
       background: #F3F3F3; 
    }
    /deep/.ant-modal-footer{
        border:none;
        text-align:center;
        padding-bottom: 40px;
        .ant-btn{
            padding:0 30px;
        }
    }
    .icon{
        text-align:center;
        i{
            font-size: 50px;
            color:#F87439;
        }
    }
    .font{
        font-size: 14px;
        font-weight: 700;
        text-align:center;
        margin-top:20px;
    }
}
</style>
